import "./App.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./views/LoginPage";
// import { AdminOnlyRoute, } from "./routes/ProtectedRoute";
import Container from "./components/Container";
import Home from "./views/Home";
import OurDojos from "./views/OurDojos";
import Contact from "./views/Contact";
import TsujiGettan from "./views/TsujiGettan";
import Lineage from "./views/Lineage";
import Curriculum from "./views/Curriculum";
import KenshiList from "./views/admin/KenshiList";
import VideoList from "./views/admin/VideoList";
import MyLesson from "./views/MyLesson";
import background from "./assets/bg.jpg";
import MugaiRyu from "./views/MugaiRyu";
import OurActivities from "./views/OurActivities";
import ScrollToTop from "./hooks/scrollToTop";
import Equipment from "./views/Equipment";

function App() {
  return (
    <div className="App min-h-screen"       
    background={`transparent url(${background})`}
    bgRepeat={"repeat"}
    minH="100vh">
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Home />}></Route>
        <Route path="/mugai-ryu" element={<MugaiRyu />}></Route>
        <Route path="/tsuji-gettan" element={<TsujiGettan />}></Route>
        <Route path="/lineage" element={<Lineage />}></Route>
        <Route path="/curriculum" element={<Curriculum />}></Route>
        <Route path="/our-activities" element={<OurActivities />}></Route>
        <Route path="/our-dojos" element={<OurDojos />}></Route>
        <Route path="/equipment" element={<Equipment />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/my-lessons" element={<MyLesson />}></Route>
          <Route
            path="/admin"
            element={
              // <AdminOnlyRoute>
                <Container />
              // </AdminOnlyRoute>
            }
          >
            <Route path="kenshi" element={<KenshiList />} />
            <Route path="video" element={<VideoList />} />
          </Route>
      </Routes>
    </div>
  );
}

export default App;
